import { useQuery } from "@tanstack/react-query";

import apiDal from "../config/apiDal";
import { Airline } from "../types";

const fetchAirlines = async (portalUid: string): Promise<Airline[]> => {
	const response = await apiDal.post("/queries/public/fetch", {
		query: "getAirlines",
		bind: {
			enterpriseUid: portalUid,
		},
	});

	return response.data.result;
};

export const useGetAirlinesByEnterpriseUid = (portalUid: string) => {
	return useQuery<Airline[]>({
		queryKey: ["getAirlines", portalUid],
		queryFn: () => fetchAirlines(portalUid),
		enabled: !!portalUid,
		initialData: [],
	});
};
